/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoodsVo } from './GoodsVo';
import {
    GoodsVoFromJSON,
    GoodsVoFromJSONTyped,
    GoodsVoToJSON,
    GoodsVoToJSONTyped,
} from './GoodsVo';

/**
 * 
 * @export
 * @interface ResponseGoodsVo
 */
export interface ResponseGoodsVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseGoodsVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseGoodsVo
     */
    message?: string;
    /**
     * 
     * @type {GoodsVo}
     * @memberof ResponseGoodsVo
     */
    data?: GoodsVo;
}

/**
 * Check if a given object implements the ResponseGoodsVo interface.
 */
export function instanceOfResponseGoodsVo(value: object): value is ResponseGoodsVo {
    return true;
}

export function ResponseGoodsVoFromJSON(json: any): ResponseGoodsVo {
    return ResponseGoodsVoFromJSONTyped(json, false);
}

export function ResponseGoodsVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseGoodsVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : GoodsVoFromJSON(json['data']),
    };
}

export function ResponseGoodsVoToJSON(json: any): ResponseGoodsVo {
    return ResponseGoodsVoToJSONTyped(json, false);
}

export function ResponseGoodsVoToJSONTyped(value?: ResponseGoodsVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': GoodsVoToJSON(value['data']),
    };
}

